import * as yup from "yup";

import { Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import { Container, GridHeader, PaperForm, Title } from "./styles";
import { getChatUuid, getUserUuid } from "functions/uuid";
import { useDispatch, useSelector } from "react-redux";

import ChatWindow from "components/ChatWindow";
import { CloseOutlined } from "@mui/icons-material";
import Loading from "components/Loading";
import React from "react";
import { RootState } from "store";
import { setChat } from "store/Chat";
import { useCreateChat } from "services/Chat";
import { useFormik } from "formik";
import { v4 as uuidV4 } from "uuid";

const validationSchema = yup.object({
  email: yup
    .string()
    .required("Entre com o seu e-mail")
    .email("E-mail inválido"),
  name: yup.string().required("Entre com o seu nome completo"),
});

const Chat: React.FC = () => {
  const chat = useSelector((root: RootState) => root.chat);
  const dispatch = useDispatch();
  const { mutate: createChat, isLoading } = useCreateChat(dispatch);

  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
    },
    validationSchema,
    onSubmit: (values) => {
      createChat({ ...values, uuid: getChatUuid() ?? uuidV4() });
    },
  });

  const exitChat = () => {
    dispatch(
      setChat({
        user: {
          name: "",
          _id: getUserUuid() ?? uuidV4(),
          email: "",
        },
        uuid: chat.uuid,
      })
    );
  };

  if (!chat.user.email || !chat.user.name) {
    return (
      <Container>
        <Loading loading={isLoading} />
        <GridHeader direction="column">
          <Grid item>
            <Title>Olá</Title>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              Digite as suas informações abaixo para continuar
            </Typography>
          </Grid>
        </GridHeader>
        <PaperForm>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <TextField
                fullWidth
                id="name"
                name="name"
                label={"Nome completo"}
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                id="email"
                name="email"
                label={"Seu e-mail"}
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item style={{ justifyContent: "flex-end", display: "flex" }}>
              <Button
                variant="contained"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                Continuar
              </Button>
            </Grid>
          </Grid>
        </PaperForm>
      </Container>
    );
  }

  return (
    <Container>
      <Loading loading={isLoading} />
      <GridHeader
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Title>Chat</Title>
        </Grid>
        <Grid item>
          <IconButton onClick={exitChat}>
            <CloseOutlined />
          </IconButton>
        </Grid>
      </GridHeader>
      <ChatWindow chatUuid={chat.uuid || ""} />
    </Container>
  );
};

export default Chat;
